export default "__VITE_ASSET__CaaMXyGU__"